var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBrowserError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.716,
    height: 131.433,
    viewBox: "0 0 146.716 131.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1028",
    "data-name": "Grupo 1028",
    transform: "translate(-1064.718 -464.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1024",
    "data-name": "Grupo 1024",
    transform: "translate(-241.282 -37.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_159",
    "data-name": "Trazado 159",
    d: "M759.725,115.036H649.477V24H759.725v91.033Z",
    transform: "translate(658.523 515.997)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_14",
    "data-name": "L\\xEDnea 14",
    x2: 110.248,
    transform: "translate(1308 561.641)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_15",
    "data-name": "L\\xEDnea 15",
    x2: 3.674,
    transform: "translate(1320.666 551.028)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_16",
    "data-name": "L\\xEDnea 16",
    x2: 3.674,
    transform: "translate(1335.776 551.028)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1023",
    "data-name": "Grupo 1023",
    transform: "translate(-303 -23.934)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 32.967,
    cy: 32.967,
    rx: 32.967,
    ry: 32.967,
    transform: "translate(1447 490)",
    fill: "#f2f2f2",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_12",
    "data-name": "L\\xEDnea 12",
    y1: 27.972,
    x2: 27.972,
    transform: "translate(1465.98 508.981)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_13",
    "data-name": "L\\xEDnea 13",
    x2: 27.972,
    y2: 27.972,
    transform: "translate(1465.98 508.981)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBrowserError);
export default __webpack_public_path__ + "static/media/close-browser-error.de866cdf7198d92be24e9033577381bc.svg";
export { ForwardRef as ReactComponent };